var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16663 2.33341C2.94561 2.33341 2.73365 2.42121 2.57737 2.57749C2.42109 2.73377 2.33329 2.94573 2.33329 3.16675V14.8334C2.33329 15.0544 2.42109 15.2664 2.57737 15.4227C2.73365 15.579 2.94561 15.6667 3.16663 15.6667H6.49996C6.9602 15.6667 7.33329 16.0398 7.33329 16.5001C7.33329 16.9603 6.9602 17.3334 6.49996 17.3334H3.16663C2.50358 17.3334 1.8677 17.07 1.39886 16.6012C0.930018 16.1323 0.666626 15.4965 0.666626 14.8334V3.16675C0.666626 2.50371 0.930018 1.86782 1.39886 1.39898C1.8677 0.93014 2.50358 0.666748 3.16663 0.666748H6.49996C6.9602 0.666748 7.33329 1.03984 7.33329 1.50008C7.33329 1.96032 6.9602 2.33341 6.49996 2.33341H3.16663ZM11.744 4.24416C12.0695 3.91872 12.5971 3.91872 12.9225 4.24416L17.0892 8.41083C17.4147 8.73626 17.4147 9.2639 17.0892 9.58934L12.9225 13.756C12.5971 14.0814 12.0695 14.0814 11.744 13.756C11.4186 13.4306 11.4186 12.9029 11.744 12.5775L14.4881 9.83342H6.49996C6.03972 9.83342 5.66663 9.46032 5.66663 9.00008C5.66663 8.53984 6.03972 8.16675 6.49996 8.16675H14.4881L11.744 5.42267C11.4186 5.09723 11.4186 4.5696 11.744 4.24416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.97aed6041bbceac689ba97df684e1474.svg";
export { ForwardRef as ReactComponent };